import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { VersionCheckService } from '../../services/version-check.service';

@Component({
  selector: 'app-version-update-banner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './version-update-banner.component.html',
})
export class VersionUpdateBannerComponent implements OnInit, OnDestroy {
  @Input() isDarkMode = false;

  updateAvailable = false;
  dismissed = false;
  private subscription: Subscription | null = null;

  constructor(private versionCheck: VersionCheckService) {}

  ngOnInit(): void {
    this.subscription = this.versionCheck.updateAvailable$.subscribe((available) => {
      this.updateAvailable = available;
    });
    this.versionCheck.start();
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    this.versionCheck.stop();
  }

  refresh(): void {
    this.versionCheck.reload();
  }
}
